"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6143],{

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Renders the <head> section of the HTML page, including meta tags, title, and favicon.
 * @param ogImage - The URL of the Open Graph image to be displayed in social media shares.
 * @param title - The title of the page.
 * @param description - The description of the page.
 */ const Head = (param)=>{
    let { ogImage ="https://birka.app/og-image.png" , title ="Birka | Your Premier Brand NFT Marketplace" , description ="Discover Birka, the leading marketplace for NFTs from your favorite brands. Explore 50+ aggregated collections from global giants like Adidas, Nike, Starbucks, and more. Own, trade, and enjoy unique digital assets today."  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keyword",
                content: "Brand NFTs, NFT Marketplace, Adidas NFT, Nike NFT, Starbucks NFT, Digital Collectibles, Blockchain Assets"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@reservoir0x"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:determiner",
                content: "the"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: "Your Premier Brand NFT Marketplace"
            })
        ]
    });
};


/***/ }),

/***/ 66918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61897);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35430);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);








const BuyNow = (param)=>{
    let { tokenId , collectionId , orderId =undefined , mutate , buttonCss , buttonProps ={} , buttonChildren  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__/* .useConnectModal */ .We)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const isInTheWrongNetwork = Boolean(signer && (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id) !== marketplaceChain.id);
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
        css: buttonCss,
        color: "primary",
        ...buttonProps,
        children: buttonChildren
    });
    const canBuy = signer && tokenId && collectionId && !isInTheWrongNetwork;
    return !canBuy ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
        css: buttonCss,
        "aria-haspopup": "dialog",
        color: "primary",
        onClick: async ()=>{
            if (isInTheWrongNetwork && switchNetworkAsync) {
                const chain = await switchNetworkAsync(marketplaceChain.id);
                if (chain.id !== marketplaceChain.id) {
                    return false;
                }
            }
            if (!signer) {
                openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
            }
        },
        ...buttonProps,
        children: buttonChildren
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__/* .BuyModal */ .zY, {
        trigger: trigger,
        tokenId: tokenId,
        collectionId: collectionId,
        orderId: orderId,
        //CONFIGURABLE: set any fees on top of orders, note that these will only
        // apply to native orders (using the reservoir order book) and not to external orders (opensea, blur etc)
        // Refer to our docs for more info: https://docs.reservoir.tools/reference/sweepmodal-1
        feesOnTopBps: [
            "0x7e2cE82d63e74b0125404D8172c12137F818aA24:150"
        ],
        onClose: (data, stepData, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__/* .BuyStep.Complete */ .hB.Complete) mutate();
        },
        onPurchaseComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Purchase Completed",
                description: "Your have purchased the NFT."
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BuyNow);


/***/ }),

/***/ 85534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61897);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59843);
/* harmony import */ var context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35430);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66373);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31407);










const List = (param)=>{
    let { token , buttonCss , buttonChildren , buttonProps , mutate  } = param;
    var _token_token, _token_token1, _token_token2, _token_token3;
    const { isDisconnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useAccount */ .mA)();
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__/* .useConnectModal */ .We)();
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    // CONFIGURABLE: Here you can configure which currencies you would like to support for listing
    let listingCurrencies = undefined;
    if (marketplaceChain.id === wagmi__WEBPACK_IMPORTED_MODULE_7__/* .mainnet.id */ .RJ.id) {
        listingCurrencies = [
            {
                contract: viem__WEBPACK_IMPORTED_MODULE_8__/* .zeroAddress */ .D,
                symbol: "ETH",
                coinGeckoId: "ethereum"
            },
            {
                contract: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                symbol: "USDC",
                decimals: 6,
                coinGeckoId: "usd-coin"
            }
        ];
    }
    const tokenId = token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId;
    const contract = token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.contract;
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
        css: buttonCss,
        color: "primary",
        ...buttonProps,
        children: buttonChildren
    });
    if ((token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.contract) && !constants_index__WEBPACK_IMPORTED_MODULE_9__/* .AllowedCollectionList.includes */ .T.includes(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.contract)) return null;
    if (isDisconnected || isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    } else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_10__/* .ListModal */ .aX, {
        trigger: trigger,
        collectionId: contract,
        tokenId: tokenId,
        feesBps: [
            "0x7e2cE82d63e74b0125404D8172c12137F818aA24:150"
        ],
        currencies: listingCurrencies,
        onClose: (data, stepData, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_10__/* .ListStep.Complete */ ["if"].Complete) mutate();
        },
        onListingComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "NFT listed",
                description: "Your NFT has been listed."
            });
        },
        onListingError: (err)=>{
            if ((err === null || err === void 0 ? void 0 : err.code) === 4001) {
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "User canceled transaction",
                    description: "You have canceled the transaction."
                });
                return;
            }
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not list token",
                description: "The transaction was not completed."
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (List);


/***/ }),

/***/ 52158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZS": function() { return /* reexport */ buttons_AcceptBid; },
  "QE": function() { return /* reexport */ buttons_Bid; },
  "Wg": function() { return /* reexport */ BuyNow/* default */.Z; },
  "hn": function() { return /* reexport */ buttons_CollectionOffer; },
  "aV": function() { return /* reexport */ List/* default */.Z; }
});

// EXTERNAL MODULE: ./components/buttons/BuyNow.tsx
var BuyNow = __webpack_require__(66918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 206 modules
var index_module = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/@wagmi/chains/dist/index.mjs
var chains_dist = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-3B7JRKV5.js + 15 modules
var chunk_3B7JRKV5 = __webpack_require__(87671);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
// EXTERNAL MODULE: ./hooks/index.ts + 5 modules
var hooks = __webpack_require__(35430);
;// CONCATENATED MODULE: ./components/buttons/CollectionOffer.tsx









const CollectionOffer = (param)=>{
    let { collection , mutate , buttonCss , buttonProps ={}  } = param;
    const router = (0,next_router.useRouter)();
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const [attribute, setAttribute] = (0,react.useState)(undefined);
    const { data: signer  } = (0,dist/* useWalletClient */.py)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    (0,react.useEffect)(()=>{
        var _router_query_attributesSelected_;
        const keys = Object.keys(router.query);
        const attributesSelected = keys.filter((key)=>key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "" && !Array.isArray(router.query[key]));
        // Only enable the attribute modal if one attribute is selected
        if (attributesSelected.length !== 1) {
            setAttribute(undefined);
            return;
        }
        const value = (_router_query_attributesSelected_ = router.query[attributesSelected[0]]) === null || _router_query_attributesSelected_ === void 0 ? void 0 : _router_query_attributesSelected_.toString();
        const key = attributesSelected[0].slice(11, -1);
        if (key && value) {
            setAttribute({
                key,
                value
            });
        }
    }, [
        router.query
    ]);
    const isSupported = !!(collection === null || collection === void 0 ? void 0 : collection.collectionBidSupported);
    const isInTheWrongNetwork = Boolean(signer && (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id) !== marketplaceChain.id);
    const isAttributeModal = !!attribute;
    // CONFIGURABLE: Here you can configure which currencies you would like to support for bidding
    let bidCurrencies = undefined;
    if (marketplaceChain.id === chains_dist/* mainnet.id */.RJ.id) {
        bidCurrencies = [
            {
                contract: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
                symbol: "WETH",
                coinGeckoId: "ethereum"
            },
            {
                contract: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                symbol: "USDC",
                decimals: 6,
                coinGeckoId: "usd-coin"
            }
        ];
    }
    if (isDisconnected || isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
            css: buttonCss,
            disabled: isInTheWrongNetwork && !switchNetworkAsync,
            onClick: async ()=>{
                if (isInTheWrongNetwork && switchNetworkAsync) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            },
            ...buttonProps,
            children: isAttributeModal ? "Attribute Offer" : "Collection Offer"
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isSupported && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* BidModal */.D7, {
            collectionId: collection === null || collection === void 0 ? void 0 : collection.id,
            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                css: buttonCss,
                ...buttonProps,
                children: isAttributeModal ? "Attribute Offer" : "Collection Offer"
            }),
            attribute: attribute,
            currencies: bidCurrencies,
            onClose: (data, stepData, currentStep)=>{
                if (mutate && currentStep == index_module/* BidStep.Complete */.NS.Complete) mutate();
            },
            onBidError: (error)=>{
                if (error) {
                    if (error.cause.code && error.cause.code === 4001) {
                        addToast === null || addToast === void 0 ? void 0 : addToast({
                            title: "User canceled transaction",
                            description: "You have canceled the transaction."
                        });
                        return;
                    }
                }
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "Could not place bid",
                    description: "The transaction was not completed."
                });
            }
        })
    });
};
/* harmony default export */ var buttons_CollectionOffer = (CollectionOffer);

// EXTERNAL MODULE: ./components/buttons/List.tsx
var List = __webpack_require__(85534);
;// CONCATENATED MODULE: ./components/buttons/Bid.tsx








const Bid = (param)=>{
    let { tokenId , collectionId , disabled , openState , buttonCss , buttonProps , mutate  } = param;
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,dist/* useWalletClient */.py)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        css: buttonCss,
        disabled: disabled,
        ...buttonProps,
        color: "gray3",
        children: "Make Offer"
    });
    // CONFIGURABLE: Here you can configure which currencies you would like to support for bidding
    let bidCurrencies = undefined;
    if (marketplaceChain.id === chains_dist/* mainnet.id */.RJ.id) {
        bidCurrencies = [
            {
                contract: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
                symbol: "WETH",
                coinGeckoId: "ethereum"
            },
            {
                contract: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                symbol: "USDC",
                decimals: 6,
                coinGeckoId: "usd-coin"
            }
        ];
    }
    if (isDisconnected || isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* BidModal */.D7, {
        tokenId: tokenId,
        collectionId: collectionId,
        trigger: trigger,
        openState: openState,
        currencies: bidCurrencies,
        onClose: (data, stepData, currentStep)=>{
            if (mutate && currentStep == index_module/* BidStep.Complete */.NS.Complete) mutate();
        },
        onBidError: (error)=>{
            if (error) {
                if (error.cause.code && error.cause.code === 4001) {
                    addToast === null || addToast === void 0 ? void 0 : addToast({
                        title: "User canceled transaction",
                        description: "You have canceled the transaction."
                    });
                    return;
                }
            }
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not place bid",
                description: "The transaction was not completed."
            });
        }
    });
};
/* harmony default export */ var buttons_Bid = (Bid);

;// CONCATENATED MODULE: ./components/buttons/AcceptBid.tsx








const AcceptBid = (param)=>{
    let { tokenId , bidId , collectionId , disabled , openState , buttonCss , buttonChildren , buttonProps , mutate  } = param;
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,dist/* useWalletClient */.py)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        css: buttonCss,
        color: "gray3",
        disabled: disabled,
        ...buttonProps,
        children: buttonChildren
    });
    const tokens = (0,react.useMemo)(()=>{
        return collectionId && tokenId ? [
            {
                collectionId: collectionId,
                tokenId: tokenId,
                bidIds: bidId ? [
                    bidId
                ] : undefined
            }
        ] : [];
    }, [
        collectionId,
        tokenId,
        bidId
    ]);
    if (isDisconnected || isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* AcceptBidModal */.wK, {
        trigger: trigger,
        openState: openState,
        tokens: tokens,
        onClose: (data, stepData, currentStep)=>{
            if (mutate && currentStep == index_module/* AcceptBidStep.Complete */.h$.Complete) {
                mutate();
            }
        },
        onBidAcceptError: (error)=>{
            if ((error === null || error === void 0 ? void 0 : error.type) === "price mismatch") {
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "Could not accept offer",
                    description: "Offer was lower than expected."
                });
                return;
            }
            // Handle user rejection
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "User canceled transaction",
                    description: "You have canceled the transaction."
                });
                return;
            }
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not accept offer",
                description: "The transaction was not completed."
            });
        }
    });
};
/* harmony default export */ var buttons_AcceptBid = (AcceptBid);

;// CONCATENATED MODULE: ./components/buttons/index.ts







/***/ }),

/***/ 33808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MobileActivityFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51528);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59417);
/* harmony import */ var components_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18491);






const MobileActivityFilters = (param)=>{
    let { activityTypes , setActivityTypes  } = param;
    const filters = [
        {
            type: "sale",
            name: "Sales",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faShoppingCart */ .sq$
        },
        {
            type: "ask",
            name: "Listings",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTag */ .LEN
        },
        {
            type: "bid",
            name: "Offers",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faHand */ .ioV
        },
        {
            type: "transfer",
            name: "Transfer",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faRightLeft */ .eRx
        },
        {
            type: "mint",
            name: "Mint",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faSeedling */ .YKZ
        }
    ];
    let filtersEnabled = activityTypes.length > 0;
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        justify: "center",
        css: {
            position: "fixed",
            left: 0,
            bottom: "70px",
            width: "100vw",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            css: {
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                position: "fixed",
                px: "$6",
                py: "$3"
            },
            type: "button",
            size: "small",
            corners: "pill",
            color: "gray3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                    style: "h6",
                    children: "Filter"
                }),
                filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                    justify: "center",
                    align: "center",
                    css: {
                        height: "24px",
                        width: "24px",
                        backgroundColor: "$gray4",
                        borderRadius: "100%",
                        fontSize: "medium",
                        fontWeight: "500"
                    },
                    children: activityTypes.length
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_3__/* .FullscreenModal */ .O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                css: {
                    flexDirection: "column",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        css: {
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4"
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                        style: "h5",
                                        css: {
                                            mr: "$3"
                                        },
                                        children: "Filter"
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                        justify: "center",
                                        css: {
                                            height: "24px",
                                            width: "24px",
                                            backgroundColor: "$gray3",
                                            borderRadius: "100%",
                                            mr: "$3"
                                        },
                                        children: activityTypes.length
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                        onClick: ()=>{
                                            setActivityTypes([]);
                                        },
                                        color: "ghost",
                                        size: "small",
                                        css: {
                                            color: "$primary11",
                                            fontWeight: 400
                                        },
                                        children: "Clear all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faXmark */ .g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        direction: "column",
                        css: {
                            p: "$4",
                            "& > div:first-of-type": {
                                pt: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                style: "subtitle1",
                                css: {
                                    mb: "$4"
                                },
                                children: "Event Type"
                            }),
                            filters.map((filter)=>{
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    css: {
                                        mb: "$3",
                                        gap: "$3"
                                    },
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                            css: {
                                                color: "$gray11"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                icon: filter.icon,
                                                width: 16,
                                                height: 16
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                            style: "body1",
                                            css: {
                                                flex: 1
                                            },
                                            children: filter.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                            align: "center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Switch */ .rs, {
                                                checked: activityTypes === null || activityTypes === void 0 ? void 0 : activityTypes.includes(filter.type),
                                                onCheckedChange: (checked)=>{
                                                    if (checked) {
                                                        setActivityTypes([
                                                            ...activityTypes,
                                                            filter.type
                                                        ]);
                                                    } else {
                                                        setActivityTypes(activityTypes.filter((item)=>{
                                                            return item != filter.type;
                                                        }));
                                                    }
                                                }
                                            })
                                        })
                                    ]
                                }, filter.name);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 61194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fw": function() { return /* binding */ CollapsibleContent; },
/* harmony export */   "Kq": function() { return /* binding */ CollapsibleRoot; },
/* harmony export */   "iM": function() { return /* binding */ slideUp; },
/* harmony export */   "qw": function() { return /* binding */ slideDown; }
/* harmony export */ });
/* unused harmony exports Collapsible, AnimatedCollapsibleContent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86744);
/* harmony import */ var _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





const slideDown = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const slideUp = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const CollapsibleContent = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_3__/* .CollapsibleContent */ .Fw, {
    background: "transparent",
    border: "none",
    borderRadius: 0
});
const CollapsibleRoot = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
    borderRadius: 8,
    overflow: "hidden"
});
const AnimatedCollapsibleContent = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return _jsx(CollapsibleContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ _jsx(motion.div, {
            ref: forwardedRef,
            initial: {
                width: 0
            },
            animate: {
                width: "100%",
                transition: {
                    mass: 1,
                    duration: 0.15
                }
            },
            exit: {
                width: 0,
                transition: {
                    duration: 0.3
                }
            },
            children: children
        })
    });
})));
const Collapsible = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(CollapsiblePrimitive.Root, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ _jsx(CollapsiblePrimitive.Trigger, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ _jsx(AnimatePresence, {
                children: open && /*#__PURE__*/ _jsx(AnimatedCollapsibleContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
})));



/***/ }),

/***/ 12623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ DropdownMenuContent; },
/* harmony export */   "Lt": function() { return /* binding */ Dropdown; },
/* harmony export */   "Xi": function() { return /* binding */ DropdownMenuItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50530);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34509);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12664);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21190);





const DropdownMenuContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuContent */ .AW, {
    mx: "$4",
    p: "$2",
    borderRadius: 8,
    zIndex: 5,
    background: "$dropdownBg",
    $$borderColor: "$colors$gray7",
    boxShadow: "0 0 0 1px $$borderColor"
});
const AnimatedDropdownMenuContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownMenuContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            initial: {
                scale: 0.9,
                opacity: 0,
                y: -20
            },
            animate: {
                scale: 1,
                opacity: 1,
                y: 0,
                transition: {
                    mass: 0.05,
                    type: "spring",
                    duration: 0.1
                }
            },
            exit: {
                y: -20,
                scale: 0.9,
                opacity: 0,
                transition: {
                    duration: 0.1
                }
            },
            children: children
        })
    });
});
const DropdownMenuItem = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuItem */ .Xi, {
    fontSize: 16,
    fontFamily: "$body",
    color: "$gray12",
    px: "$2",
    py: "$4",
    borderRadius: 8,
    outline: "none",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "$gray5"
    },
    "&:focus": {
        backgroundColor: "$gray5"
    }
});
const Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .AnimatePresence */ .M, {
                children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimatedDropdownMenuContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
});



/***/ }),

/***/ 53370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SP": function() { return /* binding */ TabsTrigger; },
/* harmony export */   "dr": function() { return /* binding */ TabsList; },
/* harmony export */   "nU": function() { return /* binding */ TabsContent; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79509);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50530);


const TabsList = (0,stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__/* .List */ .aV, {
    display: "flex",
    gap: "$5",
    borderBottom: "1px solid $gray5",
    mt: "$5",
    mb: "$4"
});
const TabsTrigger = (0,stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__/* .Trigger */ .xz, {
    fontWeight: "700",
    pb: "$3",
    '&[data-state="active"]': {
        boxShadow: "inset 0 -1px 0 0 var(--colors-violet9), 0 1px 0 0 var(--colors-violet9)"
    }
});
const TabsContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__/* .Content */ .VY, {});



/***/ }),

/***/ 59843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AllowedCollectionList; }
/* harmony export */ });
const AllowedCollectionList = [
    "0x749f5ddf5ab4c1f26f74560a78300563c34b417d",
    "0xf661d58cfe893993b11d53d11148c4650590c692",
    "0x1ff052df592ffcf42fe6a4173975d351dcc99d45",
    "0x927a51275a610cd93e23b176670c88157bc48af2",
    "0xd4190dd1da460fc7bc41a792e688604778820ac9",
    "0xcd041f40d497038e2da65988b7d7e2c0d9244619",
    "0x38544d6cc9f98968007cf91aaee4a8abe2fb37d2",
    "0xba0c9cf4da821dba98407cc4f9c11f6c7a5f9bbc",
    "0x05844e9ae606f9867ae2047c93cac370d54ab2e1",
    "0x78d61c684a992b0289bbfe58aaa2659f667907f8",
    "0xff1f1a1125184c5ad03a508ee210dc5ef3741b09",
    "0x5bfeb3bedda0acd031be68ad2aa73f574b4c0994",
    "0xfe290336a7fb1d5fdccde1c4ffeb714ab6892bc2",
    "0xa72d82e3003faadb893086b5e379194191ab472d",
    "0xe8bfe9e1ca49e7dc0c6d01bca8ae5ef5a30c8d3b",
    "0x364350d93fc86580ec23ab427c0e899083ecd599",
    "0x99b59ed222f9d228fb96ba54541731e8c6f1df64",
    "0x970b632540e075043d6ac8e8c649d4d19fbe42db",
    "0xf4052755cccf326a6791e02ceff90e243f356f23",
    "0x05844e9ae606f9867ae2047c93cac370d54ab2e1",
    "0xccdf1373040d9ca4b5be1392d1945c1dae4a862c",
    "0x212590b0dac9502e0591b79db4cedeb6356dcc36",
    "0xf661d58cfe893993b11d53d11148c4650590c692",
    "0x223e16c52436cab2ca9fe37087c79986a288fffa",
    "0x1ff052df592ffcf42fe6a4173975d351dcc99d45",
    "0x67f4732266c7300cca593c814d46bee72e40659f",
    "0xd71b53fe1df51075c5a965956cdc87421c2ffed7",
    "0x1b1b94975ff6b87013f20e2ff8fe0460e6b18b2b",
    "0xd3ed75b60b5edbf4110e778d3053fedb3e2f2a30",
    "0x0bb2053ea7621fa6324641aee6ce856a0b9f8595",
    "0xc7c9567bd3020e8148e43d0831c33d4843f0b0e1",
    "0x28472a58a490c5e09a238847f66a68a47cc76f0f",
    "0x455c732fee7b5c3b09531439b598ead4817d5274",
    "0x749f5ddf5ab4c1f26f74560a78300563c34b417d",
    "0x7ab2352b1d2e185560494d5e577f9d3c238b78c5",
    "0xd6f4a923e2ecd9ab7391840ac78d04bfe40bd5e1",
    "0x8b8d1225bb21ca07812ff3c2ee9358f7b5d90eca",
    "0xeb6c5accafd8515c1b9e4c794bdc41532c5543ec",
    "0x4bd77619a75c8eda181e3587339e7011da75bf0e",
    "0x87660380efc270677f62d8d1b45cc1d0b6c60f47",
    "0x9009ef580549252dfd13d423e5dc9b07895084a1",
    "0x364350d93fc86580ec23ab427c0e899083ecd599",
    "0xf24897f2e1668d9d2ac84d260bb5155672166407",
    "0x51a3db97d612e7ac3d8e69ed6dfea08d5ef20d3a",
    "0x8b6d881cb985c2c49e893a522735852839c58737",
    "0xf51bbb5726513b7005d25f2973309661e5206556",
    "0x038d94dfe3ebdd02af5e605b1d9e21cfcfb9d41a",
    "0x0e220a4f3957c17a2e780922dbc13cb2c9aa4274",
    "0x0477a628bd5722f56646b094126d4489b121b5ea",
    "0xbfb99893d04f72e2916c8f266e1b2962871a8dd4",
    "0x4c04517e467f25f8c95634872c505a59a60200f4",
    "0x3693345b9265b15786873ceb05af69dbadb97b93",
    "0x92a462984ac7961a0e88b196651fc19c0045e1fe",
    "0xff1f1a1125184c5ad03a508ee210dc5ef3741b09",
    "0x364350d93fc86580ec23ab427c0e899083ecd599",
    "0xd9c942b906b7c8a38eb2a9ef2d8d30cb6925db34",
    "0xabf66ca534f8a5081303e3873f0f4771c67b7b45",
    "0xf4052755cccf326a6791e02ceff90e243f356f23",
    "0x2a459947f0ac25ec28c197f09c2d88058a83f3bb",
    "0x76acf2775374b6b8731aba327447020e9d8ab869",
    "0x4ce6c369516560b1e6fa49d41096746293c0a87f",
    "0x2bd016017e1f6a7d0948334017e9037028dede98",
    "0x725d24995d500caefd8aad41b9b36bba3280f29b",
    "0xc3f3ef3929392fdc697c5800d6cd18af73377a8f",
    "0x15609d4bf09986b0cabbacab4477b965a630eadc",
    "0x653434f3bcdd1f3e09ea07552d8228bc7876713e",
    "0xe8f88d16f24255fcfab25959705d724406d67d9d",
    "0xa51df3ff6202675e8e9c95d4978a815f6ea11a0b",
    "0x2218e323ab826775e9fd026098a200606d4dd32c",
    "0xcbe4e48e6c883b313c06a002009289501178339d",
    "0xba01c17942f63fcb6f67513e5b0646b4ddf7c8c7",
    "0x71dc46607f31f30510f0ccc670b0963f431b212a",
    "0x91028695e1c266f02dff4c481669b1a48ba96d64",
    "0x7c035e6de5e6b80307747bf9c23e74cc65a3b763",
    "0xc807ce5f1fd6515cbbe9def35e086e60e720b60b",
    "0xe83a546513cc1dc8f9d3d3ddab898b54e6153cfe",
    "0x7f8cba17511ac40270bb4ef13eba47165e577cc8",
    "0x932f05045a01e679ab95a29ba383d9c0954502bf",
    "0xbd8437ca41b43bdae92d1fb68bd8b36225e78f62",
    "0x155bab02984bcaf25c60ca643688b0e4339c3bc8",
    "0xe7484f96d20ee75e146c1917d094ac64f59699cd",
    "0xf6775ad730637420c6d63fa948b564189d3a456d",
    "0xf4d215a4e75beda4bc99609b2af2702e7d2d1111",
    "0x698be66243d4431af18c377b1db82fc09af85db6",
    "0xffe99a2604ae1b606490675475b4db1aa0b9917b",
    "0x1a5dec5283a686a7efead3f25e407e7da7fb4b5f",
    "0x517cedc05f38211113e58663ed4eabed854c0f77",
    "0xf897e2cd445bdc5ac02a8d116caa2c2fb767fdf1",
    "0xeea14f2a8cfaf73736397832ab890bb28ce263bc",
    "0x96c0eb1d1c7e0fdf7eceba3474f1e681a3bf854c",
    "0x352a956fec11a743f739cd5c30a54090deec45f2",
    "0xd854add818cc7c1225624e5c6b61ba81f656ba62",
    "0x6b6ba11ffbcbdc0f22517b972278fa40650ac00f",
    "0x7044a182eb235a86713e05f25ee44531f838a9eb",
    "0x6f7164b378fdbeed629806c9bbcbbbae318dc87c",
    "0x495a0e16eac093f2fbf99b3f8da1aa5fafa4a4fe",
    "0xc3127dc36f1333f3a34ffcc21c0920ba9a6dd837",
    "0xa123d85f522a55a556ccba1e15cffc67c7afdcd8",
    "0xdc61b17587975317fb621b725c6d5be51ac9a55b",
    "0x4b5504e8619cd65692c6bbbedc54e6d7afe5bff5",
    "0x6a1c801ec142596046b0327d50b1fa6dcfd368bf",
    "0xa32e8ef4b15820cee80fa0573a957f11caec6007",
    "0x9f5dcd096e85accecf7f2b2ec0a132cf44fe7996",
    "0xfde389b3e688f12c8efd5548b93540c3f06bfbb0",
    "0x9172d60b2475060f3671e07028340c4cbaa4e263",
    "0x9c11774f5813cab12318ee6d23fb7768f95ae906",
    "0xf16ab2d54e95cf9d8922a244c1c09107c3b96888",
    "0xef90f515ceb7c02f112b277553fa0ee774bca7ea",
    "0xbf5450a58e660740cb9eed444bc3658f2a1b7bb3",
    "0xe2559f4b2f78e139ca3128b5f32d0b7d4d2bd234",
    "0x248e6d478578216822635b95c7a1970a16223836",
    "0x27931513a87b62889992a76c3d975b6c712d909d",
    "0x750314b875e8cff5baa385db3e172686ca1fce40",
    "0xa5c875a893b082edcbdf70a23b01cb10e4768865",
    "0x9d8542ef1237933badbe867291f6c0434b8d315c",
    "0x16c309b6b01402ec196e4ae9a05946f5a0f4d6c4",
    "0x3e249ae5a200230a1f25b3dee35755463156b382",
    "0xf3f1798ee4d40b78d32a2fe321d045a591e7103a",
    "0x80be35056d9467841a74dcd80253729c508cad32",
    "0xcbe6cbd8c3e73d0a3e2cd4f24e4c0dbb61299643",
    "0x7f44bce8c31386500b30e02f371e797ad3410349",
    "0x5fd0102e00ec829ef34ac4f0056a1698dfe210d9",
    "0x0f4ea45f6b9828ba6ac7400504a66d93f4c93c25",
    "0xfdba313e9d2e52299ec317a6fa05a141767e61b4",
    "0xffd17d9dd02c6bb3096528f36d0c2cb9335fac9d",
    "0x96e55659845ca96deba2b8748d8987a7d2d94f4a",
    "0xefded257ca71b9e3bbc9c0959a1ef4ad494c8897",
    "0x7ee1c07be8bf6c16c1cb3075aea488309f48b12e",
    "0xdb65b48446dc4fc383d7e91ffa64c812a1b36a4e",
    "0x02a898554a3122a07764ef1b4cedb123cbb1d075",
    "0xe2a98ba4f46fa47d938be8dfc82c82c35700c5f0",
    "0x5b9c3ef22c4f8c5308552d6e595c04ed4cbc7aa2"
];


/***/ }),

/***/ 84205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports basicFetcher, fetchWithTimeout */
/* harmony import */ var _reservoir0x_reservoir_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4495);
/* provided dependency */ var process = __webpack_require__(83454);

const fetcher = async function(url) {
    let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const headers = new Headers();
    if (process.env.NEXT_PUBLIC_RESERVOIR_API_KEY) {
        headers.set("x-api-key", process.env.NEXT_PUBLIC_RESERVOIR_API_KEY);
    }
    const path = new URL(url);
    (0,_reservoir0x_reservoir_sdk__WEBPACK_IMPORTED_MODULE_0__/* .setParams */ .PX)(path, params);
    const response = await fetch(path.href, {
        headers,
        ...data
    });
    const json = await response.json();
    return {
        data: json,
        response
    };
};
const basicFetcher = async (href, options)=>{
    const response = await fetch(href, options);
    const json = await response.json();
    return {
        data: json,
        response
    };
};
const fetchWithTimeout = async (url, options, timeout)=>{
    const controller = new AbortController();
    const signal = controller.signal;
    const timeoutId = setTimeout(()=>controller.abort(), timeout);
    try {
        const response = await fetch(url, {
            ...options,
            signal
        });
        clearTimeout(timeoutId);
        return response;
    } catch (error) {
        if (error instanceof Error) {
            if (error.name === "AbortError") {
                throw new Error("Request timed out");
            }
        }
        throw error;
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (fetcher);


/***/ }),

/***/ 94830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ DATE_REGEX; },
/* harmony export */   "x": function() { return /* binding */ timeTill; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__);


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default()));
/**
 * REGEX to parse out YYYY-MM-DD HH:MM:SS from a raw string
 * @returns YYYY-MM-DD HH:MM:SS
 */ const DATE_REGEX = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/;
/**
 * Returns a human-readable string indicating the time remaining until the provided time string.
 * @param timeString The target time string in the format "YYYY-MM-DD HH:MM:SS".
 * @returns A human-readable string indicating the time remaining until the target time.
 */ const timeTill = (timeString)=>{
    return "".concat(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(timeString).fromNow(true));
};


/***/ })

}]);